import axios from 'axios';

import { EXPEDIENTE } from './types';

import { setAlert } from './alert';
import { changeLoader } from './loader';

export const buscarArchivos = (filtros) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }

    const body = JSON.stringify(filtros);

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/expediente/listar`, body, config);

        await dispatch({
            type: EXPEDIENTE.BUSCAR,
            payload: res.data.archivos
        });
    } catch (error){
        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
}

export const filtarArchivos = (opcion) => dispatch => {
    dispatch({
        type: EXPEDIENTE.FILTROS,
        payload: opcion
    });
}

export const limpiarArchivos = () => dispatch => {
    dispatch({
        type: EXPEDIENTE.BUSCAR,
        payload: []
    });
}

export const crearArchivo = (archivo) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    }

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/expediente/crear`, archivo, config);

        await dispatch({
            type: EXPEDIENTE.BUSCAR,
            payload: res.data.archivos
        });

        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error){
        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
}

export const obtenerArchivo = (archivo) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    
    const body = JSON.stringify(archivo);

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/expediente/detalles`, body, config);

        await dispatch({
            type: EXPEDIENTE.DETALLES,
            payload: res.data.archivo
        });
    } catch (error){
        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
}

export const limpiarArchivo = () => dispatch => {
    dispatch({
        type: EXPEDIENTE.DETALLES,
        payload: null
    });
}

export const editarArchivo = (archivo) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    }

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/expediente/editar`, archivo, config);

        await dispatch({
            type: EXPEDIENTE.BUSCAR,
            payload: res.data.archivos
        });

        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error){
        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
}

export const eliminarArchivo = (id) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    }
    
    const body = {
        id_archivo: id
    };

    try{
        await dispatch(changeLoader(true));
        const res = await axios.post(`${process.env.REACT_APP_API_ROUTE}/expediente/eliminar`, body, config);

        await dispatch({
            type: EXPEDIENTE.BUSCAR,
            payload: res.data.archivos
        });
        
        await dispatch(setAlert(res.data.msg, 'success'));
    } catch (error){        
        if(error?.response?.data?.msg) {
            await dispatch(setAlert(error?.response?.data?.msg, 'danger'));
        }
    } finally {
        await dispatch(changeLoader(false));
    }
}